import type { UseRestTimerResult } from "../hooks/useRestTimer";

interface RestTimerBannerProps {
  timer: UseRestTimerResult;
}

export function RestTimerBanner({ timer }: RestTimerBannerProps) {
  if (!timer.active) return null;

  const display = formatSeconds(timer.remainingSeconds);

  return (
    <div
      role="region"
      aria-label="rest timer"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-800 bg-slate-900/95 backdrop-blur p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]"
    >
      <div className="mx-auto flex max-w-2xl flex-wrap items-center justify-between gap-2">
        <span className="text-xl font-mono tabular-nums" aria-live="polite">
          {display}
        </span>
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={() => timer.bump(-15)}
            className="rounded-md border border-slate-700 px-3 py-2 text-sm hover:bg-slate-800"
          >
            -15
          </button>
          <button
            type="button"
            onClick={() => (timer.paused ? timer.resume() : timer.pause())}
            className="rounded-md border border-slate-700 px-3 py-2 text-sm hover:bg-slate-800"
          >
            {timer.paused ? "Resume" : "Pause"}
          </button>
          <button
            type="button"
            onClick={() => timer.bump(15)}
            className="rounded-md border border-slate-700 px-3 py-2 text-sm hover:bg-slate-800"
          >
            +15
          </button>
          <button
            type="button"
            onClick={() => timer.dismiss()}
            aria-label="dismiss rest timer"
            className="rounded-md border border-red-900 px-3 py-2 text-sm text-red-300 hover:bg-red-950"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
}

function formatSeconds(s: number): string {
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, "0")}`;
}
